import React, { useState } from "react";
import { ListGroup } from "react-bootstrap";
import { i18n, _t } from "app/i18n/i18n";
import { features } from "app/features";
import { SearchBox } from "../../searchBox/SearchBox";
import { AutoSuggestions } from "./AutoSuggestions";

export function FilterAutoComplete(props) {
  const [keyword, setKeyword] = useState("");
  const [isAcVisible, setAcVisible] = useState();

  const language =
    features.reportLanguageInAutocomplete && props.useReportLanguageInAutoComplete
      ? props?.filter?.Language || [i18n.getLanguage()]
      : undefined;

  return (
    <ListGroup className="mt-1">
      <SearchBox
        keyword={keyword}
        setKeyword={setKeyword}
        setAcVisible={setAcVisible}
        isVisible={props.showAutoComplete === true}
        placeholder={_t(props.autoPlaceholder)}
        preventFormSubmit
        isSearchButtonVisible={false}
      />

      {keyword && isAcVisible && (
        <AutoSuggestions
          keyword={keyword}
          setKeyword={setKeyword}
          language={language}
          setAcVisible={setAcVisible}
          {...props}
        />
      )}
    </ListGroup>
  );
}

export const analystAutoComplete = {
  category: "Analyst",
  category_en: "analysts.name.en",
  category_ja: "analysts.name.ja",
  es_category_en: "analysts.name.en",
  es_category_ja: "analysts.name.ja",
  icon: "fa-user",
  autoPlaceholder: "Analyst name...",
  useAggs: true,
  showAutoComplete: true,
};

export const regionAutoComplete = {
  category: "Region",
  category_en: "region.en",
  category_ja: "region.ja",
  es_category_en: "region.en",
  es_category_ja: "region.ja",
  icon: "fa-user",
  autoPlaceholder: "Region name...",
  useAggs: true,
  showAutoComplete: true,
};

export const countryAutoComplete = {
  category: "Country",
  category_en: "country.en",
  category_ja: "country.ja",
  es_category_en: "country.en",
  es_category_ja: "country.ja",
  icon: "fa-globe",
  autoPlaceholder: "Country name...",
  useAggs: true,
  showAutoComplete: true,
};

export const currencyAutoComplete = {
  category: "Currency",
  category_en: "currencies.en",
  category_ja: "currencies.ja",
  es_category_en: "currencies.en",
  es_category_ja: "currencies.ja",
  icon: "fa-coins",
  autoPlaceholder: "Currency name...",
  useAggs: true,
  showAutoComplete: true,
  dedupAutocompleteSuggestions: true,
};

export const companyAutoComplete = {
  category: "CompanyWithTicker",
  category_en: "Company",
  category_ja: "Company-JA",
  es_category_en: "companies.name.en",
  es_category_ja: "companies.name.ja",
  icon: "fa-hotel",
  autoPlaceholder: "Company name...",
  useAggs: true,
  showAutoComplete: true,
};

export const tradeIdeasAutoComplete = {
  category: "Trade Ideas",
  category_en: "Trade Ideas",
  category_ja: "Trade Ideas-JA",
  es_category_en: "tradeIdeas.en",
  es_category_ja: "tradeIdeas.ja",
  icon: "fa-chart-line",
  autoPlaceholder: "Trade ideas...",
  useAggs: true,
  showAutoComplete: true,
  dedupAutocompleteSuggestions: true,
};

export const periodicalAutoComplete = {
  label: "Periodicals",
  category: "Report Titles",
  category_en: "Report Titles",
  category_ja: "Report Titles-JA",
  es_category_en: "reportTitles.en",
  es_category_ja: "reportTitles.ja",
  icon: "fas fa-newspaper",
  autoPlaceholder: "Periodical...",
  acFilter: "Report Titles",
  useAggs: true,
  showAutoComplete: true,
  useReportLanguageInAutoComplete: true,
  dedupAutocompleteSuggestions: true,
  exclusions: [
    "会社レポート",
    "Company Report (all)",
    "フラッシュレポート",
    "Flash Report (Compliation)",
    "為替クオンツ・ストラテジー",
    "FX Quantitative Strategy",
    "Japan FX Insights",
    "Japan FX Insights",
    "マクロ経済レポート（日本）",
    "MacroEconomic Report (ad hoc)",
    "マクロ経済レポート（excl. 日本）",
    "MacroEconomic Report (ad hoc, excl. Japan)",
    "Models",
    "Models",
    "オセアニア・メモ",
    "Oceania Memo",
    "ストラテジー レポート",
    "Strategy (Full report)",
    "米国マクロメモ",
    "US Macro Comment",
    "Yen Derivatives RV Analytics",
    "Yen Derivatives RV Analytics",
    "円金利デイリーモニター",
    "Yen Rates Daily Monitor",
    "Coverage update",
    "Coverage update",
    "Equity Report",
    "Equity Report",
    "Printed Report",
    "Printed Report",
    "Yen Bond Market Watch（日本語)",
    "Yen Bond Market Watch",
    "Yen RV Analytics",
    "Yen RV Analytics",
    "Yen RV Analytics (日本語）",
    "Yen RV Analytics  (Japanese Language)",
    "ストラテジーレポート",
    "Strategy (Full report)",
    "フラッシュ",
    "Flash",
    "フラッシュレポート Adjust",
    "Flash Report Adjust (Individual)",
    "プレゼンテーション",
    "Presentations",
    "和訳レポート",
    "English to Japanese report",
    "経済解析レポート",
    "Quantitative Economic Analysis",
  ],
};
